import React from "react"
import Nav from "./nav"
import secure from "../../../images/secure.svg"

const FormWrapper = ({
  children,
  isLastStep,
  goToPreviousStep,
  canGoBack,
  actionLabel,
  currentStep,
  wizard,
}) => {
  return (
    <>
      <Nav currentStep={currentStep} wizard={wizard} />
      <div className="p-lg-5 p-4">
        {children}
        <div className="row pt-5">
          <div className="col-lg-4 offset-lg-4 my-3">
            <button
              type="button"
              onClick={goToPreviousStep}
              disabled={!canGoBack}
              className={
                !canGoBack
                  ? "d-none"
                  : "btn sparkle--button__green_outline px-5 btn-block"
              }
            >
              Previous
            </button>
          </div>

          <div className="col-lg-4 my-3">
            <button
              type="submit"
              className="btn sparkle--button__green px-5 btn-block"
            >
              {actionLabel || (isLastStep ? "Submit" : "Next step")}
            </button>
          </div>
        </div>

        <div className="row justify-content-center pt-5 pb-3">
          <div className="col-lg-8">
            <div className="p-2" style={{ background: "#EAF7CC" }}>
              <p className="mb-0 text-secure text-center">
                {" "}
                <span>
                  <img src={secure} alt="" className="mr-1 mb-1" />
                </span>
                <span className="ml-4 mb-2">
                  Your given information is private and secured.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FormWrapper
